import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '免费韩漫大全_好看的韩国漫画_漫画韩漫网址_韩漫在线观看-韩国漫画网',
    description: '通过漫画网址访问韩国漫画网，即可浏览免费韩漫大全与好看韩国漫画，并支持韩漫在线观看，便捷易用。',
    url: 'http://acwaterpump.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'http://acwaterpump.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedComics />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}